<!-- @format -->

@if (reviewAISummary && totalReviews > 0) {
	<div class="hmf-px-s hmf-mt-m hmf-mt-m-l">
		<p class="hmf-display-flex hmf-align-items-center">
			<homefield-icon
				width="24px"
				height="24px"
				name="ai-star"
				fill="var(--hmf-primary600)"
				class="hmf-mr-xxxs"></homefield-icon>
			<span class="hmf-body-bold-l">Customers Say</span>
		</p>
		<p class="hmf-mb-xxs hmf-body-m">{{ reviewAISummary }}</p>
		<p class="label-secondary-subtle-static hmf-body-s">
			AI generated summary from the text of customer reviews
		</p>
	</div>
}
